import{MMKV}from'react-native-mmkv';export default new MMKV({id:`onekey-app-setting`});